import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Project from '../../api/project';
import Bg from '../../images/shapes/bg_pattern_4.svg';

const PortfolioPage = () => {
    return (
        <Fragment>
            <Header />
            <main className="page_content">
                <section className="page_banner_section text-center" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="heading_focus_text text-white">
                            Our
                            <span className="badge bg-secondary">Portfolio</span>
                        </div>
                        <h1 className="page_title mb-0 text-white">Case Studies & Projects</h1>
                        <p className="text-white mt-3 mb-0">
                            Explore our successful projects across various industries including banking, education, and commercial sectors.
                        </p>
                    </div>
                </section>
                <section className="portfolio_section section_space">
                    <div className="container">
                        <div className="row">
                            {Project.map((project, index) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={index}>
                                    <div className="card h-100 border-0 shadow-sm">
                                        <img 
                                            src={project.pImg} 
                                            className="card-img-top" 
                                            alt={project.title}
                                            style={{ height: '200px', objectFit: 'cover' }}
                                        />
                                        <div className="card-body">
                                            <span className="badge bg-primary mb-2">{project.sub}</span>
                                            <h5 className="card-title">{project.title}</h5>
                                            <p className="card-text text-muted">{project.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default PortfolioPage;
